
import { defuFn } from '/Users/macgitlabrunner1/builds/EFFy8Dyq/5/web-applications/revagency-com/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}

import cfg0 from "/Users/macgitlabrunner1/builds/EFFy8Dyq/5/web-applications/revagency-com/app.config.ts"

export default defuFn(cfg0, inlineConfig)
